import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function downloadPdf(path, filename, params) {
  try {
    const r = await axios.get(`${API}${path}`, { params, responseType: "blob" });
    const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    const a = Object.assign(document.createElement("a"), { href: url, download: filename });
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
    toast.success("PDF indirildi");
  } catch (e) {
    let msg = "PDF hazırlanamadı";
    try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch { /* keep default */ }
    toast.error(msg);
  }
}
